export default __webpack_public_path__ + "static/2371-4701fdc15b73285e1171d1be36e286f7.gif";